module.exports = __webpack_public_path__ + "img/7.c2a55c2.png";